import { render, staticRenderFns } from "./index.vue?vue&type=template&id=566c3b5c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=566c3b5c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566c3b5c')) {
      api.createRecord('566c3b5c', component.options)
    } else {
      api.reload('566c3b5c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=566c3b5c", function () {
      api.rerender('566c3b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccessControl/index.vue"
export default component.exports